<ion-item class="card-content"
          tappable
          (click)="openContactModal()"
          detail="false">
    <ion-icon slot="start" name="chatbox-ellipses"></ion-icon>
    <ion-text>
        <div>
            <div>{{faqPage.contact.name}}</div>
            <div *ngIf="faqPage.contact.description" class="contactValue">{{faqPage.contact.description}}</div>
        </div>
    </ion-text>
    <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
</ion-item>
